import { render, staticRenderFns } from "./ThePersonRolesForm.vue?vue&type=template&id=042cce21&"
import script from "./ThePersonRolesForm.vue?vue&type=script&lang=js&"
export * from "./ThePersonRolesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports